module.exports = __webpack_public_path__ + "img/icon_55.d9baa771.png";